<template>
  <nav>
    <div>
      <router-link to="/idea">IntelliJ IDEA</router-link>
      <router-link to="/rider">Rider</router-link>
    </div>
    <div class="help-controls">
      <a href="javascript:void(0)" @click="$emit('toggle-info')">
        <span v-if="showInfo">Hide help</span>
        <span v-if="!showInfo">Show help</span>
      </a>
    </div>
  </nav>
</template>

<script>
  export default {
    name: "HeaderNavigation",
    props: ['showInfo']
  }
</script>

<style lang="scss">
  nav {
    display: flex;
    justify-content: space-between;

    margin-bottom: 16px;

    a, a:visited {
      display: inline-block;
      font-weight: bold;
    }

    a + a {
      margin-left: 16px;
    }

    a:active, a:focus {
      outline: 0;
      border: none;
      -moz-outline-style: none;
    }

    a.router-link-exact-active {
      border-bottom: 3px solid hsl(204, 50%, 40%);
    }

    .help-controls {
      font-weight: normal;
      border-bottom: 1px dashed hsl(204, 50%, 40%);
    }

  }
</style>